import { Drawer } from 'vaul'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DialogProps } from './Types'
import { DrawerProps } from './Root'

export const NestedRoot = observer(({ open, stackIndex, ...props }: DialogProps & DrawerProps) => {
  const { drawersStore } = useRootStore()

  const handleClose = () => {
    drawersStore.closeDrawer()
    props.onClose?.()
  }

  const drawerOpen =
    drawersStore.drawers.length > 0 && stackIndex !== undefined && stackIndex <= drawersStore.drawers.length - 1

  return (
    <Drawer.NestedRoot
      {...props}
      open={drawerOpen}
      onOpenChange={(isOpen) => {
        if (isOpen) {
          props.onOpen?.()
        } else {
          if (drawerOpen) handleClose()
        }
      }}
    >
      {props.children}
    </Drawer.NestedRoot>
  )
})
